import type { ValueOf } from "type-fest";

export const OTP_METHODS = {
  EMAIL: "EMAIL",
  SMS: "SMS",
} as const;

export type OtpMethod = ValueOf<typeof OTP_METHODS>;
export type SMSOtpMethod = Extract<OtpMethod, "SMS">;
export type EmailOtpMethod = Extract<OtpMethod, "EMAIL">;

export const EMAIL_LOGIN_STEPS = {
  LOGIN_PASSWORD_FORM: "LOGIN_PASSWORD_FORM",
  LOGIN_OTP_FORM: "LOGIN_OTP_FORM",
  CONFIRM_OTP_FORM: "CONFIRM_OTP_FORM",
} as const;
